@let row = flight();
@let count = counts();

<kendo-tabstrip class="flight-detail" [keepTabContent]="false">
    @if (configs().enginePowerCheckEnabled) {
        <kendo-tabstrip-tab [selected]="selected() === 'enginePowerCheck'">
            <ng-template kendoTabTitle>
                {{ "FLIGHT_LIST.tabs.enginePowerCheck" | translate }}<span class="count" [class.empty]="!count.enginePowerCheck">{{ count.enginePowerCheck }}</span>
            </ng-template>
            <ng-template kendoTabContent>
                @if (row.enginePowerCheck; as check) {
                    <p class="summary">
                        <span
                            >{{ "FLIGHT_LIST.epc.oat" | translate }}: <strong>{{ check.oat }}</strong></span
                        >
                        <span
                            >{{ "FLIGHT_LIST.epc.altitude" | translate }}: <strong>{{ check.altitude }}</strong></span
                        >
                    </p>
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>N1/NG</th>
                                <th>NR</th>
                                <th>TOT/ITT</th>
                                <th>TQ</th>
                                <th>ΔN1</th>
                                <th>ΔT4</th>
                                <th>ΔTOT</th>
                                <th>ΔTQ</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (engine of [check.engine1, check.engine2]; track $index) {
                                @if (engine) {
                                    <tr>
                                        <th>{{ "FLIGHT_LIST.epc.engine" | translate: { engine: $index + 1 } }}</th>
                                        <td>{{ engine.n1Ng }}</td>
                                        <td>{{ engine.nr }}</td>
                                        <td>{{ engine.totItt }}</td>
                                        <td>{{ engine.tq }}</td>
                                        <td>{{ engine.deltaN1 }}</td>
                                        <td>{{ engine.deltaT4 }}</td>
                                        <td>{{ engine.deltaTot }}</td>
                                        <td>{{ engine.deltaTq }}</td>
                                    </tr>
                                }
                            }
                        </tbody>
                    </table>
                } @else {
                    <p class="empty-state">{{ "FLIGHT_LIST.empty.enginePowerCheck" | translate }}</p>
                }
            </ng-template>
        </kendo-tabstrip-tab>
    }

    @if (configs().penaltyFactorEnabled) {
        <kendo-tabstrip-tab [selected]="selected() === 'penaltyFactor'">
            <ng-template kendoTabTitle>
                {{ "FLIGHT_LIST.tabs.penaltyFactor" | translate }}<span class="count" [class.empty]="!count.penaltyFactor">{{ count.penaltyFactor }}</span>
            </ng-template>
            <ng-template kendoTabContent>
                @if (row.penaltyFactor; as penalty) {
                    <table class="narrow">
                        <thead>
                            <tr>
                                <th>CAT.A TRN</th>
                                <th>Wind &gt; 33 Kts</th>
                                <th>Wind &gt; 45 Kts</th>
                                <th>MTOM FH &gt; 6400</th>
                                <th>MTOM LDS &gt; 6400</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ penalty.catATRN }}</td>
                                <td>{{ (penalty.windGR33 ? "FLIGHT_LIST.yes" : "FLIGHT_LIST.no") | translate }}</td>
                                <td>{{ (penalty.windGR45 ? "FLIGHT_LIST.yes" : "FLIGHT_LIST.no") | translate }}</td>
                                <td>{{ penalty.mtomFHGR6400 }}</td>
                                <td>{{ penalty.mtomFHLDS6400 }}</td>
                            </tr>
                        </tbody>
                    </table>
                } @else {
                    <p class="empty-state">{{ "FLIGHT_LIST.empty.penaltyFactor" | translate }}</p>
                }
            </ng-template>
        </kendo-tabstrip-tab>
    }

    <kendo-tabstrip-tab [selected]="selected() === 'notes'">
        <ng-template kendoTabTitle>
            {{ "FLIGHT_LIST.tabs.notes" | translate }}<span class="count" [class.empty]="!count.notes">{{ count.notes }}</span>
        </ng-template>
        <ng-template kendoTabContent>
            @if (notes().length) {
                <table>
                    <thead>
                        <tr>
                            <th class="kind">{{ "FLIGHT_LIST.notes.kind" | translate }}</th>
                            <th>{{ "FLIGHT_LIST.notes.text" | translate }}</th>
                            <th class="date">{{ "FLIGHT_LIST.notes.date" | translate }}</th>
                            <th class="author">{{ "FLIGHT_LIST.signedBy" | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (note of notes(); track note.column + note.id) {
                            <tr>
                                <td>
                                    <span class="chip" [class]="'note-' + note.column">{{ "FLIGHT_LIST.notes." + note.column | translate }}</span>
                                    @if (note.writtenAsRemark) {
                                        <span class="hint">{{ "FLIGHT_LIST.notes.asRemark" | translate }}</span>
                                    }
                                </td>
                                <td class="text">{{ note.text }}</td>
                                <td>{{ note.date | logDate }}</td>
                                <td>
                                    @if (note.signedBy; as author) {
                                        {{ author.name }} <span class="role">{{ "FLIGHT_LIST.authors." + author.type | translate }}</span>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            } @else {
                <p class="empty-state">{{ "FLIGHT_LIST.empty.notes" | translate }}</p>
            }
        </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [selected]="selected() === 'refuel'">
        <ng-template kendoTabTitle>
            {{ "FLIGHT_LIST.tabs.refuel" | translate }}<span class="count" [class.empty]="!count.refuel">{{ count.refuel }}</span>
        </ng-template>
        <ng-template kendoTabContent>
            @if (row.refuelBeforeFirstFlight.length) {
                <table>
                    <thead>
                        <tr>
                            <th>{{ "FLIGHT_LIST.fuel.name" | translate }}</th>
                            <th>{{ "FLIGHT_LIST.fuel.remaining" | translate }}</th>
                            <th>{{ "FLIGHT_LIST.fuel.planned" | translate }}</th>
                            <th>{{ "FLIGHT_LIST.fuel.refuel" | translate }}</th>
                            <th>{{ "FLIGHT_LIST.fuel.total" | translate }}</th>
                            <th>{{ "FLIGHT_LIST.refuelLocation" | translate }}</th>
                            <th class="author">{{ "FLIGHT_LIST.signedBy" | translate }}</th>
                            <th class="date">{{ "FLIGHT_LIST.loggedAt" | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (refuel of row.refuelBeforeFirstFlight; track refuel.id) {
                            <tr>
                                <td>{{ refuel.fuelName }}</td>
                                <td>{{ refuel.remainingFuel }}</td>
                                <td>{{ refuel.fuelPlanned }}</td>
                                <td>{{ refuel.refuel }}</td>
                                <td>{{ refuel.totalFuel }}</td>
                                <td>{{ refuel.refuelLocation }}</td>
                                <td>
                                    @if (refuel.signedBy; as author) {
                                        {{ author.name }} <span class="role">{{ "FLIGHT_LIST.authors." + author.type | translate }}</span>
                                    }
                                </td>
                                <td>{{ refuel.createdAt | zonedDateTime: timeZone() }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            } @else {
                <p class="empty-state">{{ "FLIGHT_LIST.empty.refuel" | translate }}</p>
            }
        </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [selected]="selected() === 'oil'">
        <ng-template kendoTabTitle>
            {{ "FLIGHT_LIST.tabs.oil" | translate }}<span class="count" [class.empty]="!count.oil">{{ count.oil }}</span>
        </ng-template>
        <ng-template kendoTabContent>
            @if (row.oilSuppliedBeforeFlight.length) {
                <table>
                    <thead>
                        <tr>
                            @for (column of oilColumns(); track column.key) {
                                <th>{{ column.engine ? ("FLIGHT_LIST.epc.engine" | translate: { engine: column.engine }) : column.label }}</th>
                            }
                            <th class="author">{{ "FLIGHT_LIST.signedBy" | translate }}</th>
                            <th class="date">{{ "FLIGHT_LIST.loggedAt" | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (supply of row.oilSuppliedBeforeFlight; track supply.id) {
                            <tr>
                                @for (column of oilColumns(); track column.key) {
                                    <td>
                                        @if (supply[column.key]; as quantity) {
                                            {{ quantity.value }} <span class="role">{{ quantity.unit }}</span>
                                        }
                                    </td>
                                }
                                <td>
                                    @if (supply.signedBy; as author) {
                                        {{ author.name }} <span class="role">{{ "FLIGHT_LIST.authors." + author.type | translate }}</span>
                                    }
                                </td>
                                <td>{{ supply.createdAt | zonedDateTime: timeZone() }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            } @else {
                <p class="empty-state">{{ "FLIGHT_LIST.empty.oil" | translate }}</p>
            }
        </ng-template>
    </kendo-tabstrip-tab>

    @if (configs().crewEnabled) {
        <kendo-tabstrip-tab [selected]="selected() === 'crew'">
            <ng-template kendoTabTitle>
                {{ "FLIGHT_LIST.tabs.crew" | translate }}<span class="count" [class.empty]="!count.crew">{{ count.crew }}</span>
            </ng-template>
            <ng-template kendoTabContent>
                @if (row.crewData.length) {
                    <table class="narrow">
                        <thead>
                            <tr>
                                <th>{{ "FLIGHT_LIST.crew.firstName" | translate }}</th>
                                <th>{{ "FLIGHT_LIST.crew.lastName" | translate }}</th>
                                <th>{{ "FLIGHT_LIST.crew.role" | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (member of row.crewData; track member.id) {
                                <tr>
                                    <td>{{ member.firstName }}</td>
                                    <td>{{ member.lastName }}</td>
                                    <td>{{ member.crewRole }}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                } @else {
                    <p class="empty-state">{{ "FLIGHT_LIST.empty.crew" | translate }}</p>
                }
            </ng-template>
        </kendo-tabstrip-tab>
    }

    @for (list of lists(); track list.tab) {
        <kendo-tabstrip-tab [selected]="selected() === list.tab">
            <ng-template kendoTabTitle>
                {{ "FLIGHT_LIST.tabs." + list.tab | translate }}<span class="count" [class.empty]="!list.items.length">{{ list.items.length }}</span>
            </ng-template>
            <ng-template kendoTabContent>
                @if (list.items.length) {
                    <ul class="items">
                        @for (item of list.items; track item.id) {
                            <li>{{ item.name }}</li>
                        }
                    </ul>
                } @else {
                    <p class="empty-state">{{ "FLIGHT_LIST.empty." + list.tab | translate }}</p>
                }
            </ng-template>
        </kendo-tabstrip-tab>
    }

    <kendo-tabstrip-tab>
        <ng-template kendoTabTitle>
            {{ "FLIGHT_LIST.tabs.images" | translate }}<span class="count" [class.empty]="!count.images">{{ count.images }}</span>
        </ng-template>
        <ng-template kendoTabContent>
            @if (count.images) {
                <app-flight-images [flightId]="row.id" [timeZone]="timeZone()"></app-flight-images>
            } @else {
                <p class="empty-state">{{ "FLIGHT_LIST.images.none" | translate }}</p>
            }
        </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>
